export enum EnrollmentsEnum
{
    StudentEnrollment = 'StudentEnrollment',
    TeacherEnrollment = 'TeacherEnrollment',
    TaEnrollment = 'TaEnrollment',
    DesignerEnrollment = 'DesignerEnrollment',
    ObserverEnrollment = 'ObserverEnrollment'
}
